<template>
  <div>
    <form @submit.prevent="getPriceData">
      <div class="flex">
        <CustomMultiSelect
          ref="selectedCountries"
          :records="Object.values(countries)"
          :options="{placeholder: 'Выберите страну'}"
        />
        <div class="input-group">
          <input type="text" v-model="searchTitle" placeholder="Текст для поиска" required
                 class="form-control search_value">
          <div class="input-group-append">
            <LoadingButton
              title="Поиск"
              type="submit"
              :loading="loading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => {}"
              className="btn btn-outline-info br-0"
            />
            <button v-if="drugsData.length" type="button" @click="clearHistory" class="btn btn-outline-warning">очистить
              историю
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="mt-1">
      <div class="card" v-for="(dd, i) in drugsData" :key="i">
        <div class="card-header">Поиск: <strong>{{ dd.searchTitle }}</strong>
          <button @click="removeByIndex(i)" class="btn btn-sm btn-outline-danger pull-right"><i
            class="icon-fa icon-fa-remove"/></button>
        </div>
        <div class="card-body">

          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Препарат</th>
              <th>Действующее</th>
              <th>Фасовка</th>
              <th>Цена</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(d, countryId, i) in getSortedByCountry(dd.data)">
              <tr :class="{'odd':i % 2}">
                <td
                  :rowspan="(d.length + 1) + d.reduce((acc, drug) => acc + (drug?.extra_data?.prices ?? []).length, 0)">
                  <strong>{{ countries[countryId].selectTitle }}</strong>
                </td>
              </tr>
              <template v-for="drug in d">
                <tr :class="{'odd':i % 2}">
                  <td :rowspan="(drug?.extra_data?.prices ?? []).length + 1">
                    <p>{{ drug.extra_data.main_title }}</p>
                    <p class="text-muted">{{ printDate(drug.updated_at) }}</p>
                  </td>
                  <td :rowspan="(drug?.extra_data?.prices ?? []).length + 1">{{
                      drug.supplier_product?.data?.active_ingredient
                    }}
                  </td>
                </tr>
                <tr :class="{'odd':i % 2}" v-for="p in drug.extra_data.prices">
                  <td>{{ p.title }}</td>
                  <td><strong>{{ p.price }}</strong></td>
                </tr>
              </template>
            </template>
            </tbody>
          </table>

          <div v-if="false" v-for="(d, countryId) in getSortedByCountry(dd.data)" class="mr-2">
            <h5><strong>{{ countries[countryId].selectTitle }}</strong></h5>
            <div v-for="drug in d" class="card mb-1">
              <div class="card-body">
                <p class="fs-18">{{ drug.extra_data.main_title }}</p>
                <div class="flex justify-content-between"><strong>{{
                    drug.supplier_product?.data?.active_ingredient
                  }}</strong> <span class="text-muted">{{ printDate(drug.updated_at) }}</span></div>
                <div class="border-top" v-for="p in drug.extra_data.prices">
                  <p>{{ p.title }}</p>
                  <p><strong>{{ p.price }}</strong></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import CustomMultiSelect from "@/components/selects/CustomMultiSelect.vue";

export default {
  components: {CustomMultiSelect, LoadingButton},
  data() {
    return {
      loading: false,
      searchTitle: null,
      drugsData: [],
      countries: {
        2: {selectTitle: 'DE', alias: 'de', id: 2},
        5: {selectTitle: 'PL', alias: 'pl', id: 5},
        6: {selectTitle: 'FR', alias: 'fr', id: 6},
        9: {selectTitle: 'IT', alias: 'it', id: 9},
        12: {selectTitle: 'SK', alias: 'sk', id: 12},
        21: {selectTitle: 'RO', alias: 'ro', id: 21},
      }
    }
  },
  methods: {
    clearHistory() {
      this.drugsData = [];
    },
    removeByIndex(index) {
      const arr = [...this.drugsData];
      delete arr[index];
      this.drugsData = arr.filter((d) => d);
    },
    getSortedByCountry(list) {
      return list.reduce((acc, l) => {
        const countryId = l?.supplier_product?.supplier_country_id ?? 0;
        if (!acc[countryId]) acc[countryId] = [];
        acc[countryId].push(l);
        return acc;
      }, {})
    },
    async getPriceData() {
      if (!this.searchTitle) return;
      this.loading = true;
      const {data} = await api.post('/new/drugs/parser/price', {
        type: 'mediately',
        selectedCountries: (this.$refs.selectedCountries.selectedRecords ?? []).map((c) => c.id),
        searchText: this.searchTitle
      });
      if (data.success) {
        const arr = [...this.drugsData];
        arr.unshift({
          searchTitle: this.searchTitle,
          data: data.drugsData
        });
        this.drugsData = arr;
      } else {
        toastr["warning"](data.message || "Ошибка сервера");
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>

tr.odd {
  background-color: #f8f5f5;
}

p {
  margin-bottom: 1px;
}

.search_value {
  height: 43px;
}
</style>
